<app-search-ui></app-search-ui>


<nb-card>
  <nb-card-header>
    <span class="h6">Hub Replacement - {{custData['emailId']?custData['emailId']:custData['mobile']}}</span>
  </nb-card-header>
  <nb-card-body>
    <div class="summary-container">
      <nb-select placeholder="Select Type" [(ngModel)]="replacementType">
        <nb-option value="1">Replacement</nb-option>
        <nb-option value="2">Upgrade</nb-option>
      </nb-select>
      <nb-checkbox style="margin-left: 20px;" [(checked)]="deductWarranty" (checkedChange)="toggledeductWarranty($event)">Deduct Warranty</nb-checkbox>
      <p *ngIf="replacementType == 1">
        <nb-icon icon="info-outline"></nb-icon>Make sure the Old Hub is offline & New Hub is online
      </p>
      <p *ngIf="replacementType == 2">
        <nb-icon icon="info-outline"></nb-icon>Make sure the Old Hub is offline & New Hub is online
      </p>
    </div>
    <div class="summary-container">
      <nb-select [disabled]="replacementType<1" placeholder="Old HubId" filled status="info" shape="semi-round"
        fullWidth [(ngModel)]="fromHubId">
        <nb-option [value]="hub.hubId" *ngFor="let hub of custData['hubs']">{{hub.hubId}} -
          {{hub.isOnline?"Online": "Offline"}} - nodes : {{hub.nodes.length}}</nb-option>
      </nb-select>
      <br>
      <nb-icon icon="arrow-circle-down-outline" style="margin: auto;"></nb-icon>
      <nb-select [disabled]="replacementType<1" placeholder="New HubId" filled status="primary" shape="semi-round"
        fullWidth [(ngModel)]="toHubId">
        <nb-option [value]="hub.hubId" *ngFor="let hub of custData['hubs']">{{hub.hubId}} -
          {{hub.isOnline?"Online": "Offline"}} - nodes : {{hub.nodes.length}}</nb-option>
      </nb-select>
      <button *ngIf="toHubId && fromHubId && (toHubId != fromHubId)" nbButton status="primary" style="margin: 4px;"
        (click)="this.showSummary = !this.showSummary">Show
        Summary</button>
    </div>

    <div *ngIf="showSummary" class="summary-container">
      <span>
        <h6>Old Hub Details : {{fromHubId}}</h6>
        <p>fwVersion: {{hubData[fromHubId]['firmwareVersion']}}</p>
        <p>Nodes: {{hubData[fromHubId]['nodes'].length}}</p>
        <p>Status: {{hubData[fromHubId]['isOnline']?"Online":"Offline"}}</p>
        <p>Place ID: {{hubData[fromHubId]['placeId']}}</p>
      </span>

      <span>
        <h6>New Hub Details : {{toHubId}}</h6>
        <p>fwVersion: {{hubData[toHubId]['firmwareVersion']}}</p>
        <p>Nodes: {{hubData[toHubId]['nodes'].length}}</p>
        <p>Status: {{hubData[toHubId]['isOnline']?"Online":"Offline"}}</p>
        <p>Place ID: {{hubData[toHubId]['placeId']}}</p>
      </span>
    </div>
    <div *ngIf="showSummary && !replacementInProgess" class="summary-container">
      <button nbButton (click)="startOrRetryReplacementWithClickHandle('start')"> Initiate Replacement </button>
    </div>
    <div *ngIf="replacementInProgess" class="summary-container">
      <span class="h6">Replacement Status</span>
      <br>
      <p>
        {{replacementStatus['status']}}
      </p>
      <br>
      <mat-progress-bar mode="indeterminate" *ngIf="!replacementStatus['retry'] && !replacementStatus['done']"></mat-progress-bar>

      <button *ngIf="replacementStatus['retry']" nbButton (click)="startOrRetryReplacementWithClickHandle('retry')"> Retry  </button>


      <!-- <nb-stepper orientation="vertical" #stepper [linear]=true>
        <nb-step label="Validating Request">
          <h4>Step content #1</h4>
          <p class="lorem">
            Proin varius accumsan semper. Praesent consequat tincidunt sagittis. Curabitur egestas sem a ipsum bibendum,
            sit amet fringilla orci efficitur. Nam bibendum lectus ut viverra tristique. Fusce eu pulvinar magna, quis
            viverra ex. Lorem ipsum dolor sit amet, consectetur adipiscing elit. Praesent metus turpis, commodo vel
            placerat quis, lobortis in ligula.
          </p>
          <mat-progress-bar mode="indeterminate"></mat-progress-bar>
        </nb-step>
        <nb-step label="Updating Hub with Replacement FW" >
          <h4>Step content #2</h4>
          <p class="lorem">
            Proin varius accumsan semper. Praesent consequat tincidunt sagittis. Curabitur egestas sem a ipsum bibendum,
            sit amet fringilla orci efficitur. Nam bibendum lectus ut viverra tristique. Fusce eu pulvinar magna, quis
            viverra ex. Lorem ipsum dolor sit amet, consectetur adipiscing elit. Praesent metus turpis, commodo vel
            placerat quis, lobortis in ligula.
          </p>
          <mat-progress-bar mode="indeterminate" color="accent"></mat-progress-bar>
        </nb-step>
        <nb-step label="Sending Node Data">
          <h4>Step content #3</h4>
          <p class="lorem">
            Proin varius accumsan semper. Praesent consequat tincidunt sagittis. Curabitur egestas sem a ipsum bibendum,
            sit amet fringilla orci efficitur. Nam bibendum lectus ut viverra tristique. Fusce eu pulvinar magna, quis
            viverra ex. Lorem ipsum dolor sit amet, consectetur adipiscing elit. Praesent metus turpis, commodo vel
            placerat quis, lobortis in ligula.
          </p>
          <mat-progress-bar mode="indeterminate"></mat-progress-bar>
        </nb-step>
        <nb-step label="Restarting Hub">
          <h4>Step content #4</h4>
          <p class="lorem">
            Proin varius accumsan semper. Praesent consequat tincidunt sagittis. Curabitur egestas sem a ipsum bibendum,
            sit amet fringilla orci efficitur. Nam bibendum lectus ut viverra tristique. Fusce eu pulvinar magna, quis
            viverra ex. Lorem ipsum dolor sit amet, consectetur adipiscing elit. Praesent metus turpis, commodo vel
            placerat quis, lobortis in ligula.
          </p>
          <mat-progress-bar mode="indeterminate" color="accent"></mat-progress-bar>
        </nb-step>
        <nb-step label="Checking Nodes in Hub">
          <h4>Step content #5</h4>
          <p class="lorem">
            Proin varius accumsan semper. Praesent consequat tincidunt sagittis. Curabitur egestas sem a ipsum bibendum,
            sit amet fringilla orci efficitur. Nam bibendum lectus ut viverra tristique. Fusce eu pulvinar magna, quis
            viverra ex. Lorem ipsum dolor sit amet, consectetur adipiscing elit. Praesent metus turpis, commodo vel
            placerat quis, lobortis in ligula.
          </p>
          <mat-progress-bar mode="indeterminate"></mat-progress-bar>
        </nb-step>
        <nb-step label="Updating with latest FW">
          <h4>Step content #5</h4>
          <p class="lorem">
            Proin varius accumsan semper. Praesent consequat tincidunt sagittis. Curabitur egestas sem a ipsum bibendum,
            sit amet fringilla orci efficitur. Nam bibendum lectus ut viverra tristique. Fusce eu pulvinar magna, quis
            viverra ex. Lorem ipsum dolor sit amet, consectetur adipiscing elit. Praesent metus turpis, commodo vel
            placerat quis, lobortis in ligula.
          </p>
          <mat-progress-bar mode="indeterminate" color="accent"></mat-progress-bar>
        </nb-step>
        <nb-step label="Completed">
          <h4>Replacement Done</h4>
          <p class="lorem">
            Proin varius accumsan semper. Praesent consequat tincidunt sagittis. Curabitur egestas sem a ipsum bibendum,
            sit amet fringilla orci efficitur. Nam bibendum lectus ut viverra tristique. Fusce eu pulvinar magna, quis
            viverra ex. Lorem ipsum dolor sit amet, consectetur adipiscing elit. Praesent metus turpis, commodo vel
            placerat quis, lobortis in ligula.
          </p>
        </nb-step>
      </nb-stepper> -->
    </div>



  </nb-card-body>
</nb-card>
